import axios from "axios";
import type { Quote } from "../types";

const getQuote = async (): Promise<Quote> => {
  const API_URL = "https://api.api-ninjas.com/v1/quotes" as string;
  const API_KEY = "KIM3+ELyzeTrfwEz0eGd2w==hc0aTymmIq2MUQ2m" as string;
  try {
    const response = await axios.get(API_URL, {
      headers: {
        "X-Api-Key": API_KEY,
      },
    });
    return response.data[0];
  } catch (error) {
    const message = (error as Error).message;
    console.error(message);
    throw new Error(message);
  }
};

export default getQuote;
